import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { CreateSingleReport } from '../../models';
import { currencyFormatter, percentageFormatter } from '../../utils';

type ReportSummaryProps = CreateSingleReport & {
  simpleROI: number[];
  cashOnCashReturn: number[];
};

export function ReportSummary(props: ReportSummaryProps) {
  const [roi, setSimpleROI] = useState<number>(0);
  const [coc, setCocReturn] = useState<number>(0);

  const { simpleROI, cashOnCashReturn } = props;

  useEffect(() => {
    setSimpleROI(simpleROI.reduce((a, b) => a + b, 0) / simpleROI.length);
    setCocReturn(cashOnCashReturn.reduce((a, b) => a + b, 0) / cashOnCashReturn.length);
  }, [simpleROI, cashOnCashReturn]);

  return (
    <>
      <Flex
        justifyContent="center"
        fontFamily="Montserrat"
        fontSize="3xl"
        fontWeight="medium"
        color="#5A5A5A"
        mb="10"
      >
        <Box mx="5">
          <VStack align="center">
            <Text fontSize="3xl">CoC Return</Text>
            <Text color={coc >= 0 ? '#81CCA4' : '#C00000'}>{percentageFormatter(coc)}</Text>
          </VStack>
        </Box>
        <Box mx="5">
          <VStack align="center">
            <Text fontSize="3xl">ROI</Text>
            <Text color={roi >= 0 ? '#81CCA4' : '#C00000'}>{percentageFormatter(roi)}</Text>
          </VStack>
        </Box>
      </Flex>
      <Flex
        justifyContent="space-evenly"
        fontFamily="Montserrat"
        fontSize="2xl"
        fontWeight="medium"
        color="#5A5A5A"
      >
        <Box>
          <VStack align="center">
            <Text>Monthly Payment</Text>
            <Text>{currencyFormatter(props.monthlyPaymentWithTaxesAndInsurance)}</Text>
          </VStack>
        </Box>
        <Box>
          <VStack align="center">
            <Text>Principal</Text>
            <Text>{currencyFormatter(props.principal)}</Text>
          </VStack>
        </Box>
        <Box>
          <VStack align="center">
            <Text>Sum of Payments</Text>
            <Text>{currencyFormatter(props.sumOfPayments)}</Text>
          </VStack>
        </Box>
        <Box>
          <VStack align="center">
            <Text>Interest Cost</Text>
            <Text>{currencyFormatter(props.interestCost)}</Text>
          </VStack>
        </Box>
        <Box>
          <VStack align="center">
            <Text>Cash to Close</Text>
            <Text>{currencyFormatter(props.cashToClose)}</Text>
          </VStack>
        </Box>
      </Flex>
    </>
  );
}

export default ReportSummary;
